import { breakpointNumberValues } from '@styles'
import { useCallback, useEffect, useState } from 'react'

interface Props {
  width: number
  height: number
  xxs: boolean
  xs: boolean
  sm: boolean
  md: boolean
  lg: boolean
  xl: boolean
  mobile: boolean
  isMobile: boolean
  isDesktop: boolean
  isFullHd: boolean
  breakPoints: typeof breakpointNumberValues
}

const getViewportSize = () => {
  if (typeof window === 'undefined') {
    return { width: 0, height: 0 }
  }

  const doc = document.documentElement ?? document.body

  return {
    width: window.innerWidth ?? doc?.clientWidth ?? 0,
    height: window.innerHeight ?? doc?.clientHeight ?? 0
  }
}

export const useScreen = (): Props => {
  const [size, setSize] = useState(getViewportSize)

  const listener = useCallback(() => setSize(getViewportSize()), [])

  // Listen future resize events
  useEffect(() => {
    window.addEventListener('resize', listener, false)
    return () => window.removeEventListener('resize', listener, false)
  }, [])

  return {
    width: size.width,
    height: size.height,
    xxs: size.width < breakpointNumberValues.xs,
    xs: size.width < breakpointNumberValues.sm,
    sm: size.width < breakpointNumberValues.md,
    md: size.width < breakpointNumberValues.lg,
    lg: size.width < breakpointNumberValues.xl,
    xl: size.width >= breakpointNumberValues.xxl,
    mobile: size.width < breakpointNumberValues.md,
    isMobile: size.width < breakpointNumberValues.md,
    isDesktop: size.width > breakpointNumberValues.md,
    isFullHd: size.width >= breakpointNumberValues.xxxl,
    breakPoints: breakpointNumberValues
  }
}

export default useScreen
